export const getIsLegacyValidationForTicketbookEnabledMerchant = (
  merchantPublicId: string,
) => merchantListOfLegacyValidationForTicketbook.includes(merchantPublicId);

const merchantListOfLegacyValidationForTicketbook = [
  'cs-yatsu',
  'cf-koshigaya',
  'cw-kiyose',
  'cf-fujisawa',
  'cs-totsuka',
  'cf-nagareyama',
  'cf-kameari',
  'cf-fuchu',
  'cf-hachinohe',
  'cf-meguro',
  'cf-akita',
  'cf-izumi',
  'cs-tateyama',
  'cs-yokote',
  'cf-nonoichi',
  'cf-miyakojima',
  'cs-megumino',
  'cs-tsuchizaki',
  'cf-fujigaoka',
  'cf-ashiya',
  'cs-minamiutsunomiya',
  'cf-ichikawa',
  'cf-shonanlt',
  'cs-iwatsuki',
  'cf-shimokitazawa',
  'cf-hiratsuka',
  'cf-sendai',
  'cf-musashikosugi',
  'solariasports',
  'cf-uzumasa',
  'cf-aoto',
  'cf-hirosaki',
  'cf-chiba',
  'cf-alpark',
  'cf-hachioji',
  'cf-shinurayasu',
  'cf-higashine',
  'cf-gifu',
  'cf-matsumoto',
  'cf-utsunomiya',
  'cf-nishidai',
  'cf-issha',
  'cf-hitachi',
  'cf-fukuyama',
  'cf-yoga',
  'cf-misato',
  'cf-higashitotsuka',
  'cf-kgyamahana',
  'cw-hoya',
  'cf-jiyugaoka',
  'cf-ichigao',
  'cf-inagekaigan',
  'cf-mizonokuchi',
  'cf-next21',
  'cf-yachiyodai',
  'tennozu-fitnessclub',
  'cf-morioka',
  'cf-portsquare',
  'cf-kanazawa',
  'cw-shiki',
  'cf-minamiaoyama',
  'cf-shinkawasaki',
  'cw-kashiwa',
  'w21-rafre',
  'cw-naganuma',
  'cf-ozone',
  'cf-kiyosu',
  'cf-komaki',
  'cf-ryokuentoshi',
  'cw-maebashi',
  'cf-takenotsuka',
  'cw-rokkomichi',
  'cw-kitasendai',
  'cw-hirano',
  'cw-sapporo',
  'cw-omiyamiyahara',
  'cw-nokendai',
  'cw-suminoe',
  'cf-shinosaka',
  'cf-gatetower',
  'cw-minamisenju',
  'cw-higashijujo',
  'cw-takasaki',
  'cw-kotoni',
  'cw-minamikoizumi',
  'cw-tokiwadai',
  'cw-omori',
  'cw-kitamoto',
  'cw-seijo',
  'cw-otakanomori',
  'cw-okurayama',
  'cw-nishiarai',
  'cw-kawaguchi',
  'cw-fukushima',
  'cw-kamiikebukuro',
  'cw-nagatsuta',
  'cw-hiyoshi',
  'cw-abiko',
  'cw-amagasaki',
  'cw-gamo',
  'cf-kotesashi',
  'cw-nomaoike',
  'cf-motoyawata',
  'cw-kasai',
  'cf-iidabashi',
  'cw-keiseikoiwa',
  'gc24-kanda',
  'gs-isehara',
  'cf-koshigayalt',
  'gs-motoyama',
  'gs-izumiotsu',
  'gc24-kego2',
  'gs-higashiomiya',
  'gc24-gotanda',
  'cf-centerminami',
  'cf-higashinaebo',
  'cf-soga',
  'cf-mobara',
  'csg24-sanbancho',
  'gs-kobenishidai',
  'gs-fukuoka',
  'cf-natoriminamisendai',
  'csg24-gifu',
  'gs-musashishinjo',
  'cf-higashimatsuyama',
  'cf-sodegaura',
  'gs-saitama',
  'gs-toyonaka',
  'gs-wakayama',
  'gs-kumamoto',
  'cw-naruse',
  'cf-futamatagawa',
  'ptc_delta',
  'ptc_kawasaki',
  'ptc_wako',
  'ptc_tsurumi',
  'ptc_hakkei',
  'ptc_fujigaoka',
  'ptc_shinmatsudo',
  'shinki-zoom',
  'csg24-sakuradoriaoi',
  'p-yachiyo',
  'p-tsutsujigaoka',
  'p-tamachi',
  'centralsports',
  'cf-nishitokyo',
  'cf-fussa',
  'csg24-shingashi',
  'csg24-hiratsuka',
  'csg24-iriya',
  'cf-tsukuda',
  'p-iwamizawa',
  'p-ichikawashi',
  'p-izumisano',
  'p-sumida',
  'p-osakishi',
  'p-matsushimacho',
  'gc24-myorenji',
  'gc24-kamikitazawa',
  'gc24-kameari',
  'csg24-hirai',
  'csg24-nakanobu',
  'csg24-nakameguro',
  'csg24-yutenji',
  'csg24-warabi',
  'csg24-mejiro',
  'csg24-mimomi',
  'csg24-kikuna',
  'csg24-takatsuki',
  'csg24-hachimanyama',
  'csg24-kanamachi',
  'csg24-eifukucho',
  'csg24-hoshikawa',
  'tokyo_aqua',
  'sapporo-ish',
  'cf-toaasagaya',
  'cf-fukui',
  'cw-kuki',
  'cs-kawagoe',
  'cs-online',
  'cs-netshop',
  'a-spo',
  'p-ashiyashi',
  'cf-kunitachi',
];
